export default function (km) {
  return km * 0.621371;
}
